// lib
import { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { TYPE_CLASS_MAP } from '@aytm/app/stats/page/question-views/components/lib/constants'

// components
import { Button } from 'primereact/button'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/Footer.module.scss'

const Footer = ({ children, model, data, states, updateTextPrefix, onUpdateData }) => {
  const updateText = useMemo(
    () =>
      `${updateTextPrefix ? updateTextPrefix : states.updated ? 'Updat' : 'Generat'}${
        updateTextPrefix ? '' : states.loading ? 'ing' : 'e'
      } ${data.texts.update}`,
    [data.texts.update, states.loading, states.updated, updateTextPrefix]
  )
  const updateDisabled = useMemo(
    () => states.error || states.loaded || states.loading || states.disabled.update,
    [states.error, states.loaded, states.loading, states.disabled.update]
  )

  return (
    <>
      <div className={`${style.component} ${style.row} p-fluid p-col-12`}>
        <div className="p-field">
          <Button
            id={`stat-run-button-custom-question-${model.id}`}
            className={classNames(
              `stat-run-button-${TYPE_CLASS_MAP[model.type]}`,
              `-dtr-stat-run-button-${TYPE_CLASS_MAP[model.type]}`,
              'p-button-grey p-button-rounded'
            )}
            data-stat-run-button={model.id}
            label={updateText}
            loading={states.loading}
            disabled={updateDisabled}
            onClick={updateDisabled ? null : onUpdateData}
          />
        </div>
        <div className={`${style.group} ${style.children} p-fluid p-field p-col`}>{children}</div>
      </div>
    </>
  )
}

Footer.propTypes = {
  children: PropTypes.any,
  model: PropTypes.object,
  data: PropTypes.object,
  states: PropTypes.object,
  updateTextPrefix: PropTypes.string,
  onUpdateData: PropTypes.func
}

Footer.displayName = 'Footer'

export default Footer
